import "../Leyaut/subimi.css"
function Sub({text}){
    return(
        <button className="btn">{text}</button>
    )

}

export default Sub